import { useSelector } from 'react-redux';
import { selectAuthState } from '../sagas/auth/authSlice';
import { Role } from '@inosio/payments-sdk';

/* 
    Note: this is only relevant for impersonation scenarios.

    These custom hooks (and cousin useInosioUser) serve a different purpose, they allow us to fully impersonate the entity.
    The need to know the actor is driven by access and privilege restrictions that have been put in place for different entities.

    Of course, this can be achieved in a vareity of ways, but custom hooks offer a clean and re-usable way to do it.

    As you may have noticed, we also have the UI_CONTEXT_PROVIDER for when we consume functions that were otherwise reserved for the resident from the PMUI.
    It's sole purpose is to provide context to the modal and basically make them re-usable without having to rewrite them.
 */
export function usePmActor() {
  const { ipaUser: pmUser } = useSelector(selectAuthState);
  const isPmActor = pmUser?.currentProfile.isActing && pmUser?.profiles.some((p) => p.role === Role.PropertyManager || p.role === Role.PropertyManagerAdmin); // pm is impersonator

  return [isPmActor, pmUser];
}

export function usePmProfile() {
  const { ipaUser: pmUser } = useSelector(selectAuthState);
  const isPmProfile =
    !!pmUser?.profiles.find((p) => p.uuid === pmUser?.currentProfile.uuid && (p.role === Role.PropertyManager || p.role === Role.PropertyManagerAdmin)) || // pm is current principal
    (pmUser?.currentProfile.isActing && [Role.PropertyManager, Role.PropertyManagerAdmin].includes(pmUser.currentProfile.role)); // inosio user impersonating pm which is essentially a pm

  return [isPmProfile, pmUser];
}
